import { useCentrixApi } from "core/hooks/useCentrixApi";
import { useIsShopUser } from "core/hooks/useIsShopUser";
import { useRouter } from "next/router";

export function usePrivateNotes() {
  const {
    query: { paymentRequestId },
  } = useRouter();
  const isShopUser = useIsShopUser();
  return useCentrixApi({
    path: "/api/app/payment-request-private-note/by-payment-request-id/{paymentRequestId}",
    parameters: { path: { paymentRequestId: paymentRequestId as string } },
    shouldFetch: !isShopUser,
  });
}
